import { useDispatch } from "react-redux";

import useEffectOnUnmount from "../useEffectOnUnmount";

type Actions =
  | ((...args: Array<any>) => any)
  | Record<string, any>
  | (((...args: Array<any>) => any) | Record<string, any>)[];

export default function useDispatchOnUnmount(actions: Actions) {
  const _actions = Array.isArray(actions) ? actions : [actions];

  const dispatch = useDispatch();

  useEffectOnUnmount(() => {
    _actions.forEach(action => {
      dispatch(typeof action === "function" ? action() : action);
    });
  });
}
